import { formatPesoAmount } from './money';
export const DEFAULT_SALE_ROUNDING_SETTINGS = Object.freeze({
  enabled: false,
  increment: 50,
  eligiblePaymentMethods: null,
});

// Preview only: the sale transaction always calculates the authoritative discount.
export const previewSaleRounding = ({
  totalAmount,
  settings = DEFAULT_SALE_ROUNDING_SETTINGS,
  checkoutPaymentMethods = [],
  paymentTerm = 'immediate',
} = {}) => {
  const parsedTotal = Number(totalAmount);
  const totalBeforeRounding = Number.isFinite(parsedTotal) ? Math.max(Math.round(parsedTotal), 0) : 0;
  const methods = paymentTerm === 'credit' ? ['crédito'] : checkoutPaymentMethods;
  const restricted = Array.isArray(settings?.eligiblePaymentMethods);
  const requiresPaymentMethod = Boolean(settings?.enabled && restricted && !methods.length);
  const eligible = !restricted || (methods.length > 0
    && methods.every((method) => settings.eligiblePaymentMethods.includes(method)));
  const increment = Number(settings?.increment);
  const applies = settings?.enabled && eligible && [10, 50, 100].includes(increment);
  const rounded = applies ? Math.floor(totalBeforeRounding / increment) * increment : totalBeforeRounding;
  const finalTotal = rounded > 0 ? rounded : totalBeforeRounding;
  return {
    totalAmount: finalTotal,
    totalBeforeRounding,
    roundingIncrement: applies ? increment : 0,
    roundingDiscountAmount: totalBeforeRounding - finalTotal,
    requiresPaymentMethod,
  };
};

export const getSaleTotalChange = (error) => {
  const data = error?.response?.data;
  return data?.code === 'SALE_TOTAL_CHANGED' && data.purchase
    ? data.purchase
    : null;
};

// Each changed server quote needs its own confirmation before another write.
export const saveWithSaleTotalConfirmation = async ({ save, payload, confirm, onTotalChanged }) => {
  let nextPayload = payload;
  for (;;) {
    try {
      return await save(nextPayload);
    } catch (error) {
      const purchase = getSaleTotalChange(error);
      if (!purchase) throw error;
      if (onTotalChanged) await onTotalChanged(purchase);
      const accepted = await confirm({
        title: 'El total de la venta cambió',
        message: `El total actualizado es $${formatPesoAmount(Number(purchase.totalAmount))} (descuento por redondeo: $${formatPesoAmount(Number(purchase.roundingDiscountAmount || 0))}). Confirma el nuevo total para continuar.`,
        confirmLabel: 'Confirmar total',
        cancelLabel: 'Revisar venta',
        tone: 'warning',
      });
      if (!accepted) return null;
      nextPayload = { ...nextPayload, expectedTotalAmount: Number(purchase.totalAmount) };
    }
  }
};
